export default function(p) {
  let img, marklessImage;
  let gradient;
  let textWidth;
  let canvas;
  let from;
  let to;
  let yellow, blue, gray, fadedYellow;
  let font;
  let graphicLogo, nliLogo;
  let imageJustLoaded = false;
  let univers = "fonts/344CA2_1_0.ttf";
  let returns = 0;
  let stop = false;
  let reasonShapeOffset = 42;
  let reasonNumberOffset = 2;
  let imageData;

  p.draw = () => {
    p.textFont("Univers-Bold");

    p.clear();

    p.textHeight();

    if (this.img) {
      // p.blendMode(p.OVERLAY);
      p.blendMode(p.MULTIPLY);
      p.background("#fff");
      // p.background()
      p.image(
        this.img,
        this.bounds.x,
        this.bounds.y,
        this.bounds.w,
        this.bounds.h
      );
      p.filter(p.GRAY);
      // p.tint(256, 128);
      p.image(gradient, 0, 0);
      p.noTint();
      p.blendMode(p.BLEND);
    } else {
      p.image(gradient, 0, 0);
    }

    p.stroke(0);

    p.textSize(55);
    p.textLeading(58);
    p.textAlign(p.LEFT, p.BOTTOM);
    p.fill(this.mainText.fill);
    // p.stroke(this.mainText.fill);
    p.noStroke();
    p.text(
      this.capitalText,
      this.mainText.left,
      0,
      this.textWidth,
      p.height -
        this.mainText.bottom -
        10 -
        this.returns * (p.textAscent() + p.textDescent() - 12)
    );
    p.textStyle(p.NORMAL);
    p.reasonShape();

    p.image(graphicLogo, p.width - graphicLogo.width, 40);
    p.image(
      nliLogo,
      p.width - nliLogo.width - 30,
      p.height - nliLogo.height - 30
    );
  };

  p.setup = () => {
    p.textFont("Univers-Bold");
    // if (p.windowWidth < 768) {
    //   const parentSize = p.canvas.parentElement.clientWidth
    //   p.createCanvas(parentSize, parentSize)
    // } else {
    canvas = p.createCanvas(1200, 630);
    // }

    gradient = p.createGraphics(1200, 630);
    p.textSize(this.mainText.size);
    this.textWidth = 3 * p.width / 4;
    p.textHeight();
    fadedYellow = p.color("rgba(239,217,77,.85)");
    gray = p.color("rgba(76,77,79,.85)");
    yellow = p.color("#FFE01A");
    blue = p.color("#0073BB");
    from = fadedYellow;
    to = gray;
    for (var i = 0; i < p.height; i++) {
      var c = p.lerpColor(from, to, i / p.height);
      gradient.stroke(c);
      gradient.line(0, i, p.width, i);
    }
    // this.img = gradient;
    p.rectMode(p.CORNERS);
    p.noLoop();
  };

  p.preload = () => {
    univers = p.loadFont("../fonts/344CA2_0_0.ttf");
    if (this["dev-mode"]) {
      graphicLogo = p.loadImage("images/graphic-logo.svg");
      nliLogo = p.loadImage("images/nlirh-logo-notagline.svg");
    } else {
      graphicLogo = p.loadImage("/images/graphic-logo.svg");
      nliLogo = p.loadImage("/images/nlirh-logo-notagline.svg");
    }
  };

  p.setImage = () => {
    p.loadImage(this.originalImageUrl + "/-/resize/1000x/", img => {
      this.img = img;
      // this.img.loadPixels();
      p.redraw();
    });
  };

  p.reasonShape = () => {
    // p.textFont("20px Univers");
    p.textSize(24);
    const size = p.textSize();
    const width = p.textWidth(
      this.translateReason.toUpperCase() + " #" + this.reasonNumber + " "
    );
    const shape = {
      start: {
        x: this.mainText.left,
        y:
          p.height -
          this.mainText.bottom -
          this.mainText.height -
          size -
          7 -
          reasonShapeOffset
      },
      end: {
        x: this.mainText.left + width,
        y:
          p.height -
          this.mainText.bottom -
          this.mainText.height +
          7 -
          reasonShapeOffset
      }
    };
    p.fill(yellow);
    p.noStroke();
    p.beginShape();
    p.vertex(shape.start.x, shape.start.y);
    p.vertex(shape.start.x, shape.end.y);
    p.vertex(shape.end.x + 20, shape.end.y);
    p.vertex(shape.end.x + 40, shape.start.y);
    p.endShape();
    p.fill(blue);
    p.text(
      this.translateReason.toUpperCase() + " #" + this.reasonNumber,
      this.mainText.left + 12,
      0,
      this.textWidth / 2,
      p.height -
        this.mainText.bottom -
        this.mainText.height -
        reasonShapeOffset +
        reasonNumberOffset
    );
  };

  p.mousePressed = () => {
    this.dragging = false;
    if (p.mouseInCanvas()) {
      this.dragging = true;
      this.prevOffset = this.offset;
      this.dragStart = {
        x: p.mouseX,
        y: p.mouseY
      };
    }
  };
  p.mouseReleased = () => {
    this.dragging = false;
  };

  p.mouseInCanvas = () => {
    return (
      p.mouseX >= 0 &&
      p.mouseX < p.width &&
      p.mouseY >= 0 &&
      p.mouseY < p.height
    );
  };

  p.mouseDragged = () => {
    let x = p.mouseX - this.dragStart.x + this.prevOffset.x;
    let y = p.mouseY - this.dragStart.y + this.prevOffset.y;
    let offset = {};
    if (this.dragging) {
      if (p.xDragInBounds()) {
        offset.x = x;
      } else {
        offset.x = this.offset.x;
      }
      if (p.yDragInBounds()) {
        offset.y = y;
      } else {
        offset.y = this.offset.y;
      }
      this.offset = offset;
      p.redraw();
    }
  };

  // p.dragInBounds = () => {
  //   let x = p.mouseX - this.dragStart.x + this.prevOffset.x;
  //   let y = p.mouseY - this.dragStart.y + this.prevOffset.y;
  //   let xend = this.bounds.w + x;
  //   let yend = this.bounds.h + y;
  //
  //   return x <= 0 && xend >= p.width && y <= 0 && yend >= p.height;
  // };

  p.xDragInBounds = () => {
    if (this.bounds) {
      let x = p.mouseX - this.dragStart.x + this.prevOffset.x;
      let xend = this.bounds.w + x;
      return x <= 0 && xend >= p.width;
    }
  };

  p.yDragInBounds = () => {
    if (this.bounds) {
      let y = p.mouseY - this.dragStart.y + this.prevOffset.y;
      let yend = this.bounds.h + y;

      return y <= 0 && yend >= p.height;
    }
  };

  p.save = () => {
    // save two versions: one with the watermark and "share reason below", the other without
    // p.saveFrames(
    //   "Yo_te_apoyo-Reason_" + this.reasonNumber,
    //   ".png",
    //   1,
    //   1,
    //   data => {
    //     //Frame saved callback
    //     this.markedImage = data[0];
    //     this.uploadFileOnly(this.markedImage);
    //   }
    // );
    // this.offscreenMarkless.pushImage(marklessImage, 0, 0);

    imageData = p.canvas.toDataURL("image/png");

    this.uploadFile(imageData);
  };

  p.downloadMarkedImage = () => {
    if (typeof imageData !== "undefined") {
      imageData = p.canvas.toDataURL("image/png");
    }

    var anchor = document.createElement("a");

    console.log(anchor);
    anchor.setAttribute("href", imageData);
    anchor.setAttribute("download", "image.png");
    anchor.click();
  };

  p.textHeight = () => {
    //Simulate text wrap, counting the resulting lines and then calculating height in pixels
    p.textSize(this.mainText.size);
    let textHeight = 0;
    if (this.capitalText.length > 0) {
      let spaceWidth = p.textWidth(" ");
      let textInLines = [];
      let startIndex = 0;
      let lines = this.capitalText.split("\n");
      for (var h = 0; h < lines.length; h++) {
        let words = lines[h].split(" ");
        for (var i = 0; i <= words.length; i++) {
          let substring = words.slice(startIndex, i + 1).join(" ") + " ";
          if (p.textWidth(substring) > this.textWidth) {
            let lastSubstring = words.slice(startIndex, i).join(" ") + " ";
            textInLines.push(lastSubstring);
            startIndex = i;
          } else if (i === words.length) {
            textInLines.push(words.slice(startIndex, i).join(" ") + " ");
          }
        }
      }
      textHeight = textInLines.length * (p.textAscent() + p.textDescent() - 12);
    }

    this.mainText.height = textHeight;
  };
}



// WEBPACK FOOTER //
// ./scripts/onscreen.js